import {Component, DestroyRef, inject, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LocaleService} from "../../../service/locale.service";
import {Article, ArticleService} from "../../../../../backend";
import {PortalEnvironmentService} from "../../../service/portal-environment.service";
import {AbstractLazyComponent} from "../../../shared/component/abstract-lazy/abstract-lazy.component";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";


@Component({
  selector: 'app-featured-article',
  template: '',
  standalone: true,
  imports: [CommonModule],
})
export abstract class FeaturedArticleComponent extends AbstractLazyComponent implements OnInit {

  #destroyRef = inject(DestroyRef);
  articles: Article[] | undefined;

  constructor(private environmentService: PortalEnvironmentService, protected articleService: ArticleService, localeService: LocaleService) {
    super(localeService);
  }

  override ngOnInit(): void {
    this.isLoaded = false;
    super.ngOnInit();
    this.loadData();
  }

  override ngOnLanguageChange() {
    super.ngOnLanguageChange();
    this.loadData();
  }

  loadData() {
    this.isLoaded = false;
    this.articleService.findFeaturedArticles(this.getPortalId()!, this.getLocale())
      .pipe(takeUntilDestroyed(this.#destroyRef))
      .subscribe({
          next: (value: any) => {
            this.articles = value;
            this.isLoaded = true;
          },
          error: (error: any) => {
            this.isLoaded = true;
            console.log(error);
          }
        }
      );
  }

  get autoplayDelay() {
    return this.environmentService.SWIPE_AUTOPLAY_DELAY;
  }
}
